@if (productEntries?.length > 0) {
  <section [ngClass]="isSticky === true ? 'sticky' : 'header'">
    <div class="savings-total one sticky-total">
      <div class="row">
        <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
          <div class="orderTitleSticky">
            Order Total:
            @if (!updateTotal && headerLevelObj.length==0) {
              <span>
                {{subTotalVal | currency : 'USD' : 'symbol' :
                '1.2-2'}}
              </span>
            } @else {
              <ng-template [ngTemplateOutlet]="noPrice"></ng-template>
              }@if (headerLevelObj.length>0) {
              <span>$--</span>
            }
          </div>
          <p class="fw-bold m-0 p-0">Total Savings:&nbsp;@if (headerLevelObj.length==0) {
            <span class="greenfont"
              >{{totalSavings | currency : 'USD' :
            'symbol' : '1.2-2'}}</span>
            } @if (headerLevelObj.length>0) {
            <span>$--</span>
          }</p>
        </div>
      </div>
      <div class="row m-0 p-0">
        <div class="col-lg-12 col-sm-12 col-md-12">
          @if (!updateTotal) {
            <button type="button" class="btn-primary" (click)="openmodal(content)"
              [disabled]="continueDisableCheck()" [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
              @if (checkoutClicked) {
                <i class="fa fa-spinner fa-spin"></i>
              }
              Continue
            </button>
          }
          <button class="btn-secondary" (click)="updateCart()">
            Edit Cart
          </button>
        </div>
      </div>
      <div class="row m-0 p-0">
        <div class="col-md-12 col-lg-12 col-sm-12">
        <div class="fw-bold m-0 p-0">By placing this order, you agree to the <a [href]="pdfUrl" target="_blank"
            class="fw-bold tncMobile">Terms &
          Conditions</a></div>
        </div>
      </div>
    </div>
  </section>
}

<section class="preheader no-print">
  <section class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right">
    <section class="col-lg-5 col-md-5 col-sm-0 col-xs-12 p0 float-left emptyheader"></section>
    <section class="
        col-lg-3 col-md-3 col-sm-6 col-xs-12
        middle-row
        mt0
        text-right
        float-left
      ">
      <div class="totalQuantityDisplayBlock">
        <div class="quantityDisplay">
          @if (isCheckoutCartLoading) {
            <i class="fa fa-spinner fa-spin"></i>
          } @else {
            {{ getQuantity(stdCartDetails) }} Units
          }
        </div>
      </div>
      <a [routerLink]="['/Open-Catalogue/c/1']" target="" id="continueShoppingId" data-di-id="#continueShoppingId">
        <img src="/icons/{{baseSiteId}}/chevron-left.svg" alt="" class="chevron-left" />
        Continue shopping
      </a>
    </section>
    @if (productEntries?.length > 0) {
<section class="
        col-lg-4 col-md-4 col-sm-6 col-xs-12
        text-right
        float-right
        p0
        header-links
      ">
        <section class="save-document save-document-container mb1 mt0">
          <ng-template #popSaveTitle>
            Name your order and save it for future orders
          </ng-template>
          <ng-template #popSaveContent>
            <input type="text" class="save-order saveOrderCheckout" required #name="ngModel" [(ngModel)]="saveCartName"
              (keypress)="omit_special_char($event)" maxlength="30" />
            <span class="common-error required">{{ errorMsg }}</span>
            <button type="reset" class="popover-close btn btn-secondary popover-cancel-button saveOrderCheckoutBtn"
              (click)="toggleClose()">
              Cancel
            </button>
            <button class="btn btn-primary popover-cancel-button saveOrderCheckoutBtSave ml-2" type="submit"
              data-di-id="di-id-3064f17d-e97cc628" (click)="saveOrder()">
              Save
            </button>
          </ng-template>
          @if (!punchOutKey) {
            <a class="save-cart save-cart-img-section" [ngbPopover]="popSaveContent" [popoverTitle]="popSaveTitle"
              triggers="manual" #p2="ngbPopover" placement="top" (click)="toggle(p2)" container="body"
              popoverClass="popover-links saveorder-incart {{baseSiteId}}">
              <img src="/icons/{{baseSiteId}}/saved-orders-plus.png" alt="Save order" /><span>
              Add to my favorites
            </span></a>
          }
          <ng-template #popTitle><span>
            Clear cart of all products?
          </span>
        </ng-template>
        <a href="javascript:void(0)" target="" aria-label="download as" class="xls_cart xls-cart-img-section"
          id="tealium-xls" data-di-id="#tealium-xls" (click)="exportXls()">
          <img src="/icons/{{baseSiteId}}/excel_new.png" alt="" />
          <span>
            XLS
          </span></a>
          <a href="javascript:void(0)" onclick="window.print();" target="" id="printLinkId" class="print-cart-img-section"
            data-di-id="#printLinkId">
            <img src="/icons/{{baseSiteId}}/print.svg" alt="" />
            <span>
              Print
            </span></a>
          </section>
        </section>
      }
    </section>
  </section>
  @if (deleteSuccess !== '') {
    <div class="global-alerts">
      <div class="alert alert-info alert-dismissable getAccAlert">
        <button (click)="closeAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert" type="button"
          data-di-id="di-id-4f6d7b93-70563360">
          ×
        </button>
        <span class="delete-succ" [innerHTML]="deleteSuccess"></span>{{ "addToCartItems.deleteSuccessMsg" | cxTranslate }}
      </div>
    </div>
  }
  @if (addSuccess) {
    <div class="global-alerts">
      <div class="alert alert-info alert-dismissable getAccAlert">
        <button (click)="closeAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert" type="button"
          data-di-id="di-id-4f6d7b93-70563360">
          ×
        </button>
        {{ "addToCartItems.addProdSuccess" | cxTranslate }}
      </div>
    </div>
  }
  @if (orderBlock && showDangerAlert && productEntries?.length > 0) {
    <div class="global-alerts">
      <div class="alert alert-danger alert-dismissable getAccAlert">
        <button (click)="closeDangerAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert"
          type="button" data-di-id="di-id-4f6d7b93-70563360">
          ×
        </button>
        {{ "addToCartItems.orderBlockMsg" | cxTranslate }}
      </div>
    </div>
  }
  @if (productEntries?.length > 0) {
    <section class="standart-cart">
      <div class="row whitebg">
        <div class="col-sm-4 mb-orderSubtotal">
      <aside class="
      col-md-12 col-sm-12
      right-navigation
      float-left
      left-align
      cart-main-page" aria-label="subTotal">
            <section class="savings-total p-0 two" [ngClass]="isSticky === true ? 'header' : ''">
              <div class="row">
                <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
                  <div class="orderTitleSticky">
                    Order Total:
                    @if (headerLevelObj.length==0 && !updateTotal) {
                      <span>
                        {{subTotalVal | currency : 'USD' : 'symbol' :
                        '1.2-2'}}
                      </span>
                    } @else {
                      <ng-template [ngTemplateOutlet]="noPrice"></ng-template>
                      }@if (headerLevelObj.length>0) {
                      <span>$--</span>
                    }
                  </div>
                  <p class="fw-bold m-0 p-0 totalSaveMobile">Total Savings:&nbsp;@if (headerLevelObj.length==0) {
                    <span class="greenfont"
                      >{{totalSavings |
                      currency : 'USD' :
                    'symbol' : '1.2-2'}}</span>
                  }
                  @if (headerLevelObj.length>0) {
                    <span>$--</span>
                  }
                </p>
              </div>
            </div>
            @if (!updateTotal) {
              <button type="button" class="btn-primary" (click)="openmodal(content)"
                [disabled]="continueDisableCheck() || checkoutClicked" [ngClass]="(orderBlock || yfEntry || checkoutClicked) ? 'disableCTA' : ''">
                @if (checkoutClicked) {
                  <i class="fa fa-spinner fa-spin"></i>
                }
                <!-- {{'addToCartItems.proceedToCheckout'|cxTranslate}} -->
                Continue
              </button>
            }
            <button class="btn-secondary" (click)="updateCart()">
              Edit Cart
            </button>
            <div class="row m-0 p-0">
              <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="fw-bold m-0 p-0">By placing this order, you agree to the</div>
              </div>
            </div>
            <div class="row m-0 p-0">
              <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="fw-bold marginbot p-0"><a href="{{pdfUrl}}" target="_blank" class="fw-bold"
                class="tncMobile">Terms & Conditions</a></div>
              </div>
            </div>
          </section>
          <section>
          </section>
        </aside>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 md-ipad-8">
        @if (!punchoutCheckout) {
          <div class="row whitebg">
            <section class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 bord-Right">
              <section class="row">
                <section class="col-md-12 select-Header-Section">
                  <section class="select-Header">
                    {{'selectVaccines.order_contract'|cxTranslate}}
                  </section>
                </section>
              </section>
              <div class="row marginleftCls">
                <div class="col-lg-7 col-md-7 col-sm-12 order2">
                  <div class="row alignleftTopCls">
                    <section class="col-12 ">
                      <section class="select-Header-normal">
                        Preferred contact method
                      </section>
                    </section>
                  </div>
                  <div class="row alignleftTopCls">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <input type="radio" class="checkmark" id="radio-btn" class="radioChecked" name="orderConfirmation"
                        value="email" (click)="cMethodElection('email')" checked />
                      <label for="cntctPrefEml" class="Fields-label email-lable">
                      Email</label>
                    </div>
                  </div>
                  @for (itm of emailArr; track itm; let emailIndex = $index) {
                    <div class="row alignleftCls mb-1">
                      <div id="emailCheckout" class="col-lg-8 col-md-8 col-sm-8 spacebottomAddemail">
                        @if (cMethodVal && baseSiteId=='vsh') {
                          <ng-select [readonly]="" [searchable]="false"
                            [clearable]="false" bindLabel="name" bindValue="isocode" placeholder="Please select"
                            class="dropdown-credit" [(ngModel)]="itm.value" name="email_{{emailIndex}}"
                            (change)="addnewEmail($event,emailIndex,'cMethodVal')">
                            <ng-option value="" disabled>Select Email Address</ng-option>
                            @for (email of contactDetails?.customerEmails; track email) {
                              <ng-option [value]="email"><span
                              [ngClass]="{'newEmaildrpdwncls': email == 'Add new email'}">{{email}}</span></ng-option>
                            }
                          </ng-select>
                        }
                        @if (cMethodVal && baseSiteId!='vsh') {
                          <ng-select [readonly]="" [searchable]="false"
                            [clearable]="false" bindLabel="name" bindValue="isocode" placeholder="Please select"
                            class="dropdown-credit" [(ngModel)]="itm.value" name="email_{{emailIndex}}"
                            (change)="addnewEmail($event,emailIndex,'cMethodVal')">
                            <ng-option value="" disabled>Select Email Address</ng-option>
                            @for (email of contactDetails?.customerEmails; track email) {
                              <ng-option [value]="email"><span
                              [ngClass]="{'newEmaildrpdwncls1': email == 'Add new email'}">{{email}}</span></ng-option>
                            }
                          </ng-select>
                        }
                        @if (!cMethodVal) {
                          <ng-select [readonly]="" [disabled] [searchable]="false" [clearable]="false"
                            bindLabel="name" bindValue="isocode" placeholder="Please select" class="dropdown-credit disabled"
                            [(ngModel)]="itm.value" name="email_{{emailIndex}}" (change)="addnewEmail($event,emailIndex,'')">
                            <ng-option value="" disabled>Select Email Address</ng-option>
                            <ng-option value="ns">Nothing Selected</ng-option>
                            @for (email of contactDetails?.customerEmails; track email) {
                              <ng-option [value]="email">{{email}}</ng-option>
                            }
                            <ng-option value="-1">Add new email</ng-option>
                          </ng-select>
                        }
                      </div>
                      @if (emailIndex!=0) {
                        <div class="col-md-4 col-sm-4 spacebottomAddemail-right mt-3">
                          <ng-template #popTitleDelete>
                            Delete this item from your cart?
                          </ng-template>
                          <ng-template #popContentDelete>
                    <button type="reset" class="
                    popover-close
                    btn
                    white-button
                    popover-cancel-button
                    cart-cancel
                  " data-di-id="di-id-d01008be-fb6e135c" (click)="toggle(p1)">
                              Cancel
                            </button>
                    <button class="
                    btn
                    blue-button
                    popover-cancel-button
                    cart-delete
                  " type="submit" data-di-id="di-id-3064f17d-e97cc628" (click)="
                    deleteEmail(itm)
                  ">
                              Delete
                            </button>
                          </ng-template>
                          <a [ngbPopover]="popContentDelete" [popoverTitle]="popTitleDelete" triggers="manual" #p1="ngbPopover"
                            placement="top" class="trash cart-edit-delete" (click)="deleteEmail(emailIndex)">
                            <img src="/icons/{{baseSiteId}}/trash.svg" alt="Delete" />
                            Delete
                          </a>
                        </div>
                      }
                      @if (itm.id=='-1') {
                        <div class="col-lg-8 col-md-8 col-sm-8 spacebottomAddemail">
                          <input type="text" class="formElement" style="width: 100%" name="newEmail_{{emailIndex}}"
                            id="newEmail_{{emailIndex}}" [(ngModel)]="itm.itemValue" (blur)="emailNullCheckValidation()">
                        </div>
                      }
                      @if (itm.iserror) {
                        <div class="errorlabel">{{ErrMsg}}</div>
                      }
                    </div>
                  }
                  <div class="row alignleftTopCls">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      @if (!noshowaddemail) {
                        <label class="ordrCntrctAddEmail greenbtm" (click)="addemail()">Add
                        email</label>
                      }
                    </div>
                  </div>
                  @if (showFax) {
                    <div class="row alignleftTopCls">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <input type="radio" class="checkmark" id="radio-btn" class="radioChecked" name="orderConfirmation"
                          (click)="cMethodElection('fax')" value="fax" />
                        <label for="cntctPrefEml" class="Fields-label fax-lable">
                        Fax</label>
                      </div>
                    </div>
                    <div class="row alignleftCls">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        @if (contactDetails) {
                          @if (cMethodVal) {
                            <input #faxnumber type="text" class="formElement" placeholder="XXX-XXX-XXXX"
                              appPhoneMask disabled id="faxcontactmethod" [(ngModel)]="contactDetails.contactFax">
                          }
                          @if (!cMethodVal) {
                            <input #faxnumber type="text" class="formElement" maxlength="12"
                              (click)="updateValidity()" placeholder="XXX-XXX-XXXX" appPhoneMask id="faxcontactmethod"
                              (keyup)="validateFaxNumber(faxnumber.value,'fax',0)" [(ngModel)]="contactDetails.contactFax">
                          }
                        }
                      </div>
                    </div>
                    @if (!faxValid) {
                      <span class="redmsg">Please enter fax number</span>
                      }<br />
                      @if (!faxErrorMsg) {
                        <span class="redmsg">Invalid Fax Number</span>
                      }
                    }
                    @if (isAsmUser && contactDetails?.salesRepEmail) {
                      <div class="row alignleftTopCls">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                          <label for="salesRepEmail" class="Fields-label mt-0">Email</label>
                        </div>
                      </div>
                    }
                    @if (isAsmUser && contactDetails?.salesRepEmail) {
                      <div class="row alignleftCls mb-2">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                          <input type="text" disabled class="formElement" id="salesRepEmail"
                            [(ngModel)]="contactDetails.salesRepEmail">
                        </div>
                      </div>
                    }
                  </div>
                  <div class="col-lg-5 col-md-5 col-sm-12 order1">
                    <div class="row alignleftTopCls">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <label for="cntctPrefEml" class="Fields-label mt-0">
                        Order Placed By</label>
                      </div>
                    </div>
                    <div class="row alignleftCls">
                      @if (!isAsmUser) {
                        <div class="col-lg-12 col-md-12 col-sm-12">
                          @if (contactDetails) {
                            <input #name type="text" class="formElement" id="orderBy" (keyup)="validateOrderByName(name.value)"
                              [(ngModel)]="contactDetails.contactName" required><br />
                              @if (orderByErrorMsg) {
                                <span class="redmsg">Please enter name</span>
                              }
                            }
                          </div>
                        }
                        @if (isAsmUser) {
                          <div class="col-lg-12 col-md-12 col-sm-12">
                            <input #name type="text" class="formElement" id="orderByAsm" (keyup)="validateOrderByName(name.value)"
                              [(ngModel)]="contactDetails.asmContactName" required><br />
                              @if (orderByErrorMsg) {
                                <span class="redmsg">Please enter name</span>
                              }
                            </div>
                          }
                        </div>
                        <div class="row alignleftTopCls">
                          <div class="col-lg-12 col-md-12 col-sm-12">
                            <label for="cntctPrefEml" class="Fields-label mt-0">
                            Phone</label>
                          </div>
                        </div>
                        <div class="row alignleftCls">
                          <div class="col-lg-12 col-md-12 col-sm-12">
                            @if (contactDetails) {
                              <input #phonenumber type="text" maxlength="12" class="formElement" id="faxcontactmethod"
                                (keyup)="validateFaxNumber(phonenumber.value,'phone',0)"
                                [(ngModel)]="contactDetails.contactPhone"><br />
                                @if (!phoneErrorMsg) {
                                  <span class="redmsg">This field is required</span>
                                }
                              }
                            </div>
                          </div>
                          <div id="registerBilling" class="row alignleftTopCls">
                            <ng-template #errorPopContent>Add mobile number to receive shipping/delivery texts</ng-template>
                            <div class="col-lg-12 col-md-12 col-sm-12">
                              <label for="cntctPrefEml" class="Fields-label mt-0">
                                Mobile <a placement="top" [ngbPopover]="errorPopContent"><img
                                src="/icons/{{baseSiteId}}/faqs-plum.svg" alt="faq_reg"
                              class="faq" /></a></label>
                            </div>
                          </div>
                          @for (mobile of mobileList; track mobile; let mobindex = $index) {
                            <div class="row alignleftCls">
                              <div class="col-lg-8 col-md-8 col-sm-8 mb-1">
                                <input #mobilenumber type="text" class="formElement" placeholder="xxx-xxx-xxxx"
                                  (keyup)="validateFaxNumber(mobile.value,'mobile',mobindex)" maxlength="12"
                                  [(ngModel)]="mobile.value" id="faxcontactmethod_{{mobindex}}" name="faxcontactmethod_{{mobindex}}">
                                @if (mobile.iserror) {
                                  <span class="redmsg">Invalid Mobile Number</span>
                                }
                              </div>
                              @if (mobindex!=0) {
                                <div class="col-md-4 col-sm-4 mobileTrash" style="margin-top:8px">
                                  <a [ngbPopover]="popContentDelete" [popoverTitle]="popTitleDelete" triggers="manual" #p1="ngbPopover"
                                    placement="top" class="trash cart-edit-delete" (click)="deleteMobile(mobindex)">
                                    <img src="/icons/{{baseSiteId}}/trash.svg" alt="Delete" />
                                    Delete
                                  </a>
                                </div>
                              }
                            </div>
                          }
                          <div class="row alignleftTopCls">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                              @if (!noshowaddmobile) {
                                <label class="ordrCntrctAddEmail greenbtm" (click)="addMobile()">Add mobile
                                number</label>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      @for (user of fluProductsList; track user; let i = $index) {
                        <section class="row row-Gap" id="{{user.code}}">
                          <section class="col-2 col-sm-1 col-md-1 col-lg-1 col-xl-1 prod-Image-Section mt-3">
                            <a (click)="productDetails(user)">
                              @if (user.thumbNailImg !== '') {
                                <img src="{{baseUrl}}{{user.thumbNailImg}}" class="prod-Image"
                                  title="{{user.name}}" alt="prodImg" />
                              }
                              @if (user.thumbNailImg == '') {
                                <img
                                  [src]="'/icons/'+baseSiteId+'/sanofi_missing_product.jpg'" class="prod-Image"
                                  title="{{user.name}}" alt="defImg" />
                              }
                            </a>
                          </section>
                          <section class="col-10 col-sm-4 col-md-6 col-lg-6 col-xl-6 prod-Desc-Div mt-1">
                            <section class="container">
                              <section class="row">
                                <a (click)="navigatePDP(user)" class="col-md-12 col-lg-12 col-xl-12 product-Desc-Section"
                                  [innerHTML]="user.variantProductDescription">
                                </a>
                                @if (user?.ageIndication) {
                                  <section class="col-md-12 col-lg-12 col-xl-12 age-indication mt-2">
                                    <span>{{user?.ageIndication}}</span>
                                  </section>
                                }
                                <section class="col-md-12 col-lg-12 col-xl-12 prod-No mt-2">
                                  <span class="prodct-No">{{user.code}}</span><span class="mr-1 ml-1">|</span>
                                  <span>{{user.manufacturer}}</span>
                                </section>
                              </section>
                            </section>
                          </section>
                          <!-- ============================Price=========================================== -->
                          <section class="col-7 col-sm-7 col-md-3 col-lg-3 col-xl-3 i-Padding">
                            <section class="container">
                              <section class="row pdt-price">
                                <section class="col-md-12 col-lg-12 col-xl-12">
                                  <span class="your-Price">{{'selectVaccines.yourPrice'|cxTranslate}}</span><br />
                                  <span>$</span><br />
                                  <a [ngbPopover]=viewSavings placement="top" #s3="ngbPopover" triggers="manual"
                                    popoverClass="savedordermini-popover"
                                  (click)="deletePopup(s3,item)">{{'selectVaccines.viewSaving'|cxTranslate}}</a><br />
                                  <div class="mt-2">{{'selectVaccines.pricePrompt'|cxTranslate}}</div>
                                  <span>$</span>
                                  <ng-template #viewSavings>
                                    <table class="view-savings w-100">
                                      <tbody>
                                        <tr>
                                          <td>{{'selectVaccines.yourPrice'|cxTranslate}}</td>
                                          <td>$--</td>
                                        </tr>
                                        <tr>
                                          <td>{{'selectVaccines.directSaving'|cxTranslate}}</td>
                                          <td>$--</td>
                                        </tr>
                                        <tr>
                                          <td>{{'selectVaccines.onlineSavings'|cxTranslate}}<sup>2</sup></td>
                                          <td>$--</td>
                                        </tr>
                                        <tr class="price-savings">
                                          <td>{{'selectVaccines.yourPriceSavings'|cxTranslate}}</td>
                                          <td>$--</td>
                                        </tr>
                                        <tr class="prompt-pay">
                                          <td>{{'selectVaccines.promptPayDiscount'|cxTranslate}}<sup>3</sup></td>
                                          <td>$--</td>
                                        </tr>
                                        <tr class="price-savings">
                                          <td>{{'selectVaccines.yourPricePay'|cxTranslate}}</td>
                                          <td>$--</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </ng-template>
                                </section>
                                @if (!user?.discontinued && user?.available) {
                                  <section class="col-md-12 col-lg-12 col-xl-12 vol-Pricing"
                                    >
                                    @if (user?.volumePrices?.length > 0) {
                                      <a class="link vol-Price" placement="top"
                                        [ngbPopover]="popContent" popoverTitle="{{'selectVaccines.volumePrice'|cxTranslate}}">
                                        {{'selectVaccines.volumePrice'|cxTranslate}}
                                      </a>
                                    }
                                    <ng-template #popContent>
                                      <table class="tb" id="vol-price-pdp" aria-describedby="volTable">
                                        <thead>
                                          <th scope="col"></th>
                                        </thead>
                                        @for (prices of user?.volumePrices; track prices; let i = $index) {
                                          <tbody>
                                            <tr>
                                              <td>{{prices?.minQuantity}} - {{prices?.maxQuantity}}
                                                {{'selectVaccines.units'|cxTranslate}}:
                                              </td>
                                              <td>{{prices?.value | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
                                              <td>@if (i>0) {
                                                <span class="save-price">{{'selectVaccines.save'|cxTranslate}}
                                                  {{user?.volumePrices[0].value - user?.volumePrices[i].value | currency : 'USD' :
                                                  'symbol' : '1.2-2'}}
                                                </span>
                                              }
                                            </td>
                                          </tr>
                                        </tbody>
                                      }
                                    </table>
                                  </ng-template>
                                </section>
                              }
                            </section>
                          </section>
                        </section>
                        <!-- ==============================units========================================== -->
                        <section class="col-5 col-sm-5 col-md-2 col-xs-6 p0 pad-Port">
                          <section class="container p0">
                            <section class="units">
                              <div class="prodUnits">{{'selectVaccines.units'|cxTranslate}}</div>
                              <section class="unit-area">
                                <span class="disabled " aria-hidden="true" id="{{'minusIcon'+user?.code}}">
                                  <img src="/icons/{{baseSiteId}}/less.svg" id="{{'unitMinus'+user?.code}}"
                                    class="disabled-img" alt=""
                                    (click)="performQuantityComputation(2,user?.code,user?.quantityPerUnit,user?.uom)">
                                  <img src="/icons/{{baseSiteId}}/less-disable.svg"
                                    id="{{'unitMinusDisable'+user?.code}}" alt="">
                                </span>
                                <input type="number" class="prod-quantity text-center" value="{{'0'}}"
                                  onkeypress="return /[0-9a-zA-Z]/i.test(event.key)" (keydown)="validateInput($event)"
                                  (keyup)="performQuantityComputation(null,user?.code,user?.quantityPerUnit,user?.uom)"
                                  id="{{'prodQuantity'+user?.code}}" min="0" max="99999" appNoMouseScroll />
                                <span aria-hidden="true" id="{{'plusIcon'+user?.code}}">
                                  <img src="/icons/{{baseSiteId}}/more.svg"
                                    (click)="performQuantityComputation(1,user?.code,user?.quantityPerUnit,user?.uom)"
                                    id="{{'unitPlus'+user?.code}}" alt="">
                                  <img src="/icons/{{baseSiteId}}/more-disable.svg"
                                    id="{{'unitPlusDisable'+user?.code}}" class="disabled-img" alt="">
                                </span>
                              </section>
                              <section class="doses-section" id="{{'noOfDoses'+user?.code}}">
                                {{'0' }} {{user?.uom}}
                              </section>
                              @if (user?.orderable==true  && user?.soldOut==true) {
                                <span class="available-now">
                                  {{user?.soldOutMessageCreate}}
                                </span>
                              }
                              @if (user?.orderable==true  && user?.soldOut==false && user?.shipNow=='ON' && user?.waitlist==false) {
                                <span class="available-order"
                                  >
                                  {{'selectVaccines.available'|cxTranslate}}
                                </span>
                              }
                              @if (user?.orderable==true && user?.soldout==false && user?.waitlist==true) {
                                <span class="wait-list">
                                  {{'selectVaccines.waitlist'|cxTranslate}}
                                </span>
                              }
                            </section>
                            <ng-template #NotAccept>
                              <section class="units-Non-Accepting">
                                @if (!user.available && user.discontinued===false) {
                                  <span class="Not-Available">
                                    {{user?.availabilityText ? user?.availabilityText :
                                    ('selectVaccines.product_unavailable'|cxTranslate)}}
                                  </span>
                                }
                                @if (user.discontinued===true) {
                                  <span class="" class="Not-Available">
                                  {{'selectVaccines.product_discontinued'|cxTranslate}}</span>
                                }
                              </section>
                            </ng-template>
                          </section>
                        </section>
                        @if (fluProductsList.length>1 && i<fluProductsList.length-1) {
                          <section class='col-md-12 col-lg-12 col-xl-12'
                            >
                            <hr>
                            </section>
                          }
                        </section>
                      }
                    </section>
                  </div>
                }
                <div class="row whitebg bord-Right">
                  <div class="col-12">
          <section class="
          col-12
          left-section
          float-left
          cart-left" [ngClass]="punchoutCheckout ? 'section-height-punchout' : 'section-height'">
                      <section class="cart-accordion">
                        <!-- accordion:start-->
                        @for (locSpecificCart of stdCartDetails; track locSpecificCart; let i = $index) {
                          <div class="sanofi-accordion">
                            <div class="panel-group">
                              <div class="panel panel-default">
                                <div class="panel-heading">
                                  <section class="first-level-acc ">
                                    @if (deliveryPickup=='delivery') {
                                      <section class="deli_loc clear_fix">
                                        <section class="cart_shipto col-sm-6 col-md-6 col-lg-6 cart_shipto pl0">
                                          <section class="firstLevel-acc cartShipToHeader ">
                                            <section class="">
                                              <section class="ship-address">
                                                <section id="location-select">
                                                  <section class="location-icon">
                                                    <span class="glyph-icon">
                                                      <i class="fas fa-map-marker-alt icon mr-3"></i>
                                                    </span>
                                                  </section>
                                                  <section class="location-Details">
                                                    <span class="selected-loc">
                                                      {{locSpecificCart.shipToLoc_name}}
                                                      ({{locSpecificCart?.shipToLoc_id}})
                                                    </span>
                                                    <p class="ordercontctdetails">
                                                      <!-- 7TH AND FORRESTER STS RM B24 BSMT<br />
                                                      HARRISBURG, PA 17120-0001 -->
                                                      {{locSpecificCart?.shipToParty?.shippingAddress?.formattedAddress}}
                                                    </p>
                                                  </section>
                                                </section>
                                              </section>
                                            </section>
                                          </section>
                                        </section>
                                        @if (!locSpecificCart.futureShipAdded) {
                                          <section class=" col-sm-6 col-md-6 col-lg-6 float-right"
                                            >
                                            <div class="row">
                                              <div class="col-sm-12 col-md-12 col-lg-12 alignRight">
                                                <div class="row">
                                                  <div class="col-md-6 col-sm-6 col-lg-6 m-0 p-0 mb-delivery delLabelMobile">
                                                    <h6 class="fw-bold" style="float:right; margin-right:5px;">
                                                      Requested delivery date
                                                    </h6>
                                                  </div>
                                                  <div class="col-md-6 col-sm-6 col-lg-6 m-0 p-0 mb-delivery delDateMobile">
                                                    <section class="control-group fw-normal">
                                                      {{getRequestedDate(locSpecificCart.requestedDeliveryDate)}}
                                                    </section>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </section>
                                        }
                                      </section>
                                    }
                                    @if (deliveryPickup=='pickup') {
                                      <section class="ship_addr clear_fix">
                                        <section class="col-sm-4 col-md-4 col-lg-4 cart_shipto pl0 float-left">
                                          <h6>{{'addToCartItems.pickLocation'|cxTranslate}}</h6>
                                          <p>
                                            {{'addToCartItems.sanofiName'|cxTranslate}}<br>{{'addToCartItems.locationLine1'|cxTranslate}}<br>{{'addToCartItems.locationLine2'|cxTranslate}}
                                          </p>
                                        </section>
                                        <section class=" col-sm-6 col-md-6 col-lg-6 px0 float-left" [hidden]="getExpandedItems(i)">
                                          <section class="delivery-content">
                                            <section class="delivary-details cart-pickup-date">
                                              <h6 class="requested-date"> {{'addToCartItems.pickupDate'|cxTranslate}}</h6>
                                              <section class="calender">
                                                <section class="form-horizontal mb0">
                                                  <section class="control-group float-left">
                                                    <section class="controls input-append date cart-delivery-date-picker" data-date=""
                                                      data-date-format="mm/dd/yyyy" data-link-field="dtp_input2"
                                                      data-link-format="mm/dd/yyyy">
                                                      <span class="add-on"><i class="icon-th"></i>
                                                    </span>
                                                    <input type="text" placeholder="DD/MM/YYYY" class="delivery-pickup-calendar"
                                                      bsDatepicker [(ngModel)]="pickupDate" [minDate]="minPickupDate"
                                                      [daysDisabled]="[0,6]" [maxDate]="maxPickupDate"
                                                      (bsValueChange)="onPickupDateChange($event)"
                                                      [bsConfig]="{ containerClass: 'theme-green deliveryPickup' }">
                                                  </section>
                                                </section>
                                                <ng-select [items]="timeFormat" bindLabel="name" bindValue="selectedTime"
                                                  [multiple]="false" name="selectedTime" placeholder="Set Time"
                                                  [(ngModel)]="selectedTime" [searchable]="false">
                                                </ng-select>
                                              </section>
                                            </section>
                                          </section>
                                          <p class="pickupTextMsg">
                                            {{'addToCartItems.pickupMsg'|cxTranslate}}
                                            <br>{{'addToCartItems.customerService'|cxTranslate}}
                                              {{'addToCartItems.customerServiceNo'|cxTranslate}}
                                            </p>
                                          </section>
                                        </section>
                                      </section>
                                    }
                                    <span class="accMinusIcon fa-minus acc-plus-icon fa plusMinusIcon"
                                      [hidden]="getExpandedItems(i)" (click)="toggleAccordion(i)">
                                    </span>
                                    <span class="accPlusIcon fa-plus acc-plus-icon fa plusMinusIcon" [hidden]="!getExpandedItems(i)"
                                      (click)="toggleAccordion(i)">
                                    </span>
                                  </section>
                                </div>
                                <div id="pdp-list2" class="panel-collapse">
                                  <div class="panel-body">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <section [hidden]="getExpandedItems(i)" class="row col-sm-12 pdp-list-data" style="margin-left:0%;">
                              <section class="col-lg-1 col-md-1 displayNoneForDevice">&nbsp;</section>
                              @if (!punchOutKey) {
                                <section class="col-lg-5 col-md-5 col-sm-12 mb-pl-10 purchase-order">
                                  <div class="row col-sm-12">
                                    <div class="col-md-12 marginbtm">
                                      <!--bnot sure why beow logic added based on 1st product and that too on shipNow flag.
                                      ideally should be based on flu flag-->
                                      @if (locSpecificCart.entries[0]?.product?.shipNow!='ON') {
                                        <span class="fw-bold">Purchase order
                                          #<br />
                                          @if (!locSpecificCart?.poMandatory) {
                                            <span class="fw-normal">(Optional)</span>
                                          }</span>
                                        }
                                        @if (locSpecificCart.entries[0]?.product?.shipNow=='ON') {
                                          <span class="fw-bold">Influenza
                                            Vaccine
                                            PO #<br />
                                            @if (!locSpecificCart?.poMandatory) {
                                              <span class="fw-normal">(Optional)</span>
                                            }</span>
                                          }
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12 marginbtm">
                                          <input type="text" class="formElement ponum" maxlength="35" appPhoneMask
                                            [(ngModel)]="locSpecificCart.POnumber" name="po_{{i}}" id="po_{{i}}"
                                            (keyup)="poCheck(locSpecificCart)"
                                            [ngClass]="locSpecificCart?.poMandatory && locSpecificCart?.poError && locSpecificCart?.POnumber?.trim()?.length==0 ? 'red-border' : 'normal-border'">
                                        </div>
                                        @if (locSpecificCart?.poMandatory && locSpecificCart?.poError && locSpecificCart?.POnumber?.trim()?.length==0) {
                                          <div class="defaulterrormsg ml-4 pb-1"
                                            >
                                            This field is required by your organization.
                                          </div>
                                        }
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12 marginbtm">
                                          <span class="fw-bold">Attention<span class="fw-normal">(Optional)</span></span>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12 marginbtm">
                                          <input type="text" class="formElement" maxlength="35" name="atten_{{i}}"
                                            [(ngModel)]="locSpecificCart.attention" placeholder="John Smith"
                                            onkeypress="return /[a-z 0-9]/i.test(event.key)" id="atten_{{i}}">
                                          </div>
                                        </div>
                                      </section>
                                    }
                                    <section class="col-lg-5 col-md-6 col-sm-12 mb-pl-10 mb-pt-10">
                                      <table class="alignRight mb-location">
                                        <tr>
                                          <td class="ff-bold">Location subtotal</td>
                                          <td class="fw-normal" style="text-align:right;">
                                            @if (headerLevelObj.length==0) {
                                              <span
                                                >{{locSpecificCart.subTotal.value+locSpecificCart.totalExciseTax.value
                                                |
                                              currency : 'USD' : 'symbol' : '1.2-2'}}</span>
                                            }
                                            @if (headerLevelObj.length>0) {
                                              <span>$--</span>
                                            }
                                          </td>
                                        </tr>
                                        @if (salesTaxFlag=='y') {
                                          <tr>
                                            <td class="ff-bold">Sales tax
                                            </td>
                                            <td class="fw-normal" style="text-align:right;">
                                              @if (headerLevelObj.length==0) {
                                                <span>{{locSpecificCart?.totalSalesTaxPrice?.value |
                                                  currency :
                                                'USD' : 'symbol' : '1.2-2'}}</span>
                                              }
                                              @if (headerLevelObj.length>0) {
                                                <span>$--</span>
                                              }
                                            </td>
                                          </tr>
                                        } @else {
                                          @if (locSpecificCart?.totalSalesTaxPrice && locSpecificCart?.totalSalesTaxPrice?.value>0) {
                                            <tr>
                                              <td class="ff-bold">Sales tax
                                              </td>
                                              <td class="fw-normal" style="text-align:right;">
                                                @if (headerLevelObj.length==0) {
                                                  <span>{{locSpecificCart?.totalSalesTaxPrice?.value |
                                                    currency :
                                                  'USD' : 'symbol' : '1.2-2'}}</span>
                                                }
                                                @if (headerLevelObj.length>0) {
                                                  <span>$--</span>
                                                }
                                              </td>
                                            </tr>
                                          }
                                        }
                                        @if (locSpecificCart.totalWebDiscount.value!=0) {
                                          <tr>
                                            <td class="ff-bold vshSave">{{baseSiteId=="vsh"?"VaccineShop Savings":"VaxServe.com Savings"}}
                                            </td>
                                            <td class="greenfont" style="text-align:right;">
                                              @if (headerLevelObj.length==0) {
                                                <span>{{locSpecificCart.totalWebDiscount.value |
                                                  currency :
                                                'USD' : 'symbol' : '1.2-2'}}</span>
                                              }
                                              @if (headerLevelObj.length>0) {
                                                <span>$--</span>
                                              }
                                            </td>
                                          </tr>
                                        }
                                        @if (otherDiscountsFlag=='y') {
                                          <tr>
                                            <td class="ff-bold vshSave">Other discounts
                                            </td>
                                            <td class="greenfont" style="text-align:right;">{{locSpecificCart?.totalOtherDiscount?.value |
                                              currency : 'USD' : 'symbol' : '1.2-2'}}
                                            </td>
                                          </tr>
                                        } @else {
                                          @if (locSpecificCart?.totalOtherDiscount && locSpecificCart?.totalOtherDiscount?.value!=0) {
                                            <tr
                                              >
                                            <td class="ff-bold vshSave">Other discounts
                                            </td>
                                            <td class="greenfont" style="text-align:right;">{{locSpecificCart?.totalOtherDiscount?.value |
                                              currency :
                                              'USD' : 'symbol' : '1.2-2'}}
                                            </td>
                                          </tr>
                                        }
                                      }
                                      <tr>
                                        <td class="ff-bold-grey">Location total</td>
                                        <td class="ff-bold-grey" style="text-align:right;">
                                          @if (headerLevelObj.length==0) {
                                            <span> {{locSpecificCart.totalPrice.value |
                                            currency : 'USD' : 'symbol' : '1.2-2' }}</span>
                                          }
                                          @if (headerLevelObj.length>0) {
                                            <span>$--</span>
                                          }
                                        </td>
                                      </tr>
                                    </table>
                                  </section>
                                  <div class="col-12">
                                    <section class="row">
                                      <div class="col-md-12">
                                        <div class="panel-body">
                                          @for (productentry of locSpecificCart?.entries; track productentry; let j = $index) {
                                            <section class="pdp-list-data"
                                              >
                                              <section class="row row-20 pdp-list-product-data shiftRight">
                                                <div class="col-md-1 img-left">
                                                  <section class="col-xs-12 col-sm-7 col-md-7 col-lg-7 pr0 cart_print">
                                                    <a (click)="productDetails(productentry,i)">
                                                      <img class="image-product"
                                                        src="{{getImage(productentry.product?.images,'thumbnail')}}" alt="Product Img">
                                                    </a>
                                                  </section>
                                                </div>
                                                <div class="col-md-10 cart_print marginleftCls img-right">
                                                  <h2 class="prod-title prodDes" [innerHTML]="productentry?.product?.baseProductName"
                                                  (click)="productDetails(productentry,i)"></h2>
                                                  <section class="checkout-data">
                                                    <p [innerHTML]="productentry?.product?.baseProductDescription" class="productCodeLink"
                                                    (click)="productDetails(productentry,i)"></p>
                                                    <p [innerHTML]="stdFluDesc(productentry)" class="productCodeLink"
                                                    (click)="productDetails(productentry,i)"></p>
                                                    @if (productentry.product?.ndcCode) {
                                                      <p class="ndcCode">
                                                      {{productentry.product?.ndcCode}}</p>
                                                    }
                                                    <div>
                                                      <p class="card-text">
                                                        <!-- <span class="num-bold">{{itm?.description}}</span><br /> -->
                                                        <span><strong>{{productentry?.product?.code}}</strong> |
                                                      {{productentry?.product?.manufacturer}}</span>
                                                      @if (productentry?.contractName) {
                                                        <span
                                                          [ngStyle]="{ 'margin-left': '10px'}"><strong>Contract Group:</strong>
                                                        {{productentry?.contractName}}</span>
                                                      }
                                                    </p>
                                                  </div>
                                                  @if (productentry.product?.innerText && productentry.product?.innerText !== '') {
                                                    <p class="inner-text"
                                                      >
                                                      <span [innerHtml]="productentry?.product?.innerText"></span>
                                                    </p>
                                                  }
                                                </section>
                                              </div>
                                            </section>
                                            <section class="row marginleftCls">
                                              <section class="col-sm-12 col-md-12 col-lg-12 data-pad">
                                                <table id="example1" style="width: 100%;"
                                                  class="display account_invoice_financials dataTable no-footer">
                                                  <thead>
                                                    <tr class="heading">
                                                      <th id="table1col1" class="date-new no-sort">Status</th>
                                                      <th id="table1col2" class="date-new no-sort">Total Units</th>
                                                      <th id="table1col3" class="invoice no-sort">Units in shipment</th>
                                                      <th id="table1col4" class="po no-sort">Ship date</th>
                                                      <th id="table1col5" class="invoice-amount no-sort right">Unit Price</th>
                                                      <th id="table1col6" class="discount no-sort right">Unit Excise Tax</th>
                                                      <th id="table1col7" class="no-sort right">Subtotal</th>
                                                    </tr>
                                                  </thead>
                                                  @if ((!productentry.futureShipExpProd || (productentry.futureShipExpProd && productentry.splitEntriesDeliveryDates.length==0 ))) {
                                                    <tbody class="datatable-row"
                                                      >
                                                      <tr class="odd dateshow">
                                                        <td rowspan="2" headers="table1col1">Open</td>
                                                        <td>{{productentry?.quantity}}</td>
                                                        <td>{{productentry?.quantity}}</td>
                                                        <td>
                                                          <!-- {{isFutershipAdded==false?getRequestedDate(locSpecificCart.requestedDeliveryDate):getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated) -->
                                                          {{getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated)
                                                        </td>
                                                        <td class="right">
                                                          @if (!productentry?.product?.hidePriceForProduct) {
                                                            <span
                                                              >{{productentry?.basePrice?.value
                                                              | currency : 'USD' :
                                                            'symbol' : '1.2-2'}}</span>
                                                          }
                                                          @if (productentry?.product?.hidePriceForProduct) {
                                                            <span>$--</span>
                                                          }
                                                        </td>
                                                        <td class="right">@if (!productentry?.product?.hidePriceForProduct) {
                                                          <span
                                                            >{{productentry.exciseTax.value
                                                            | currency : 'USD' :
                                                          'symbol' : '1.2-2'}}</span>
                                                        }
                                                        @if (productentry?.product?.hidePriceForProduct) {
                                                          <span>$--</span>
                                                        }
                                                      </td>
                                                      <td class="right">
                                                        @if (!productentry?.product?.hidePriceForProduct) {
                                                          <span
                                                            >{{(productentry?.basePrice?.value+productentry.exciseTax.value)*productentry?.quantity
                                                            | currency : 'USD' :
                                                          'symbol' : '1.2-2'}}</span>
                                                        }
                                                        @if (productentry?.product?.hidePriceForProduct) {
                                                          <span>$--</span>
                                                        }
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                }
                                                @if (productentry.futureShipExpProd && productentry.splitEntriesDeliveryDates.length>0) {
                                                  <tbody class="datatable-row"
                                                    >
                                                    @for (item of productentry.splitEntriesDeliveryDates; track item; let i = $index) {
                                                      <tr class="odd dateshow"
                                                        >
                                                        @if (i==0) {
                                                          <td [attr.rowspan]="productentry?.splitEntriesDeliveryDates?.length"
                                                          headers="table1col1">{{i==0?'Open':' '}}</td>
                                                        }
                                                        @if (i>0) {
                                                          <td></td>
                                                        }
                                                        <td>{{i==0?productentry.quantity:item.splitQuantity}}</td>
                                                        <td style="white-space: pre-line"
                                                          [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,item.splitQuantity,'quantity')">
                                                        </td>
                                                        <td style="white-space: pre-line"
                                                        [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,'','date')"></td>
                                                        <td class="right">
                                                          {{i==0?'$'+productentry?.basePrice?.value:''}}
                                                        </td>
                                                        <td class="right">{{i==0?(productentry.sim_excise_tax.value | currency : 'USD' :
                                                        'symbol' : '1.2-2'):''}}</td>
                                                        <td class="right">
                                                          {{i==0?(((productentry?.basePrice?.value+productentry.sim_excise_tax.value)*productentry.quantity)|
                                                          currency : 'USD' :
                                                          'symbol' : '1.2-2'):''}}
                                                        </td>
                                                      </tr>
                                                    }
                                                  </tbody>
                                                }
                                              </table>
                                              <table id="mb-example1" style="width: 100%;"
                                                class="display account_invoice_financials dataTable no-footer">
                                                @if ((!productentry.futureShipExpProd || (productentry.futureShipExpProd && productentry.splitEntriesDeliveryDates.length==0 ))) {
                                                  <tbody class="datatable-row"
                                                    >
                                                    <tr class="odd dateshow">
                                                      <td class="left-td">Status</td>
                                                      <td>Open</td>
                                                    </tr>
                                                    <tr class="odd dateshow">
                                                      <td class="left-td">Total Units</td>
                                                      <td>{{productentry?.quantity}}</td>
                                                    </tr>
                                                    <tr class="odd dateshow">
                                                      <td class="left-td">Units in shipment</td>
                                                      <td>{{productentry?.quantity}}</td>
                                                    </tr>
                                                    <tr class="odd dateshow">
                                                      <td class="left-td">Ship date</td>
                                                      <td>
                                                        {{getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated)
                                                      </td>
                                                    </tr>
                                                    <tr class="odd dateshow">
                                                      <td class="left-td">Unit Price</td>
                                                      <td class="right">{{productentry.totalPrice.value/productentry.quantity | currency
                                                        : 'USD' :
                                                        'symbol' : '1.2-2'}}
                                                      </td>
                                                    </tr>
                                                    <tr class="odd dateshow">
                                                      <td class="left-td">Unit Excise Tax</td>
                                                      <td class="right">{{productentry.sim_excise_tax.value | currency : 'USD' :
                                                      'symbol' : '1.2-2'}}</td>
                                                    </tr>
                                                    <tr class="odd dateshow">
                                                      <td class="left-td">Subtotal</td>
                                                      <td class="right">
                                                        {{((productentry.totalPrice.value+productentry.sim_excise_tax.value)*productentry.quantity)
                                                        | currency : 'USD' :
                                                        'symbol' : '1.2-2'}}
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                }
                                                @if (productentry.futureShipExpProd && productentry.splitEntriesDeliveryDates.length>0) {
                                                  <tbody class="datatable-row"
                                                    >
                                                    @for (item of productentry.splitEntriesDeliveryDates; track item; let i = $index) {
                                                      <tr class="odd dateshow"
                                                        >
                                                        <td rowspan="2" headers="table1col1">{{i==0?'Open':' '}}</td>
                                                        <td>{{i==0?productentry.quantity:item.splitQuantity}}</td>
                                                        <td style="white-space: pre-line"
                                                          [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,item.splitQuantity,'quantity')">
                                                        </td>
                                                        <td style="white-space: pre-line"
                                                        [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,'','date')"></td>
                                                        <td class="right">
                                                          {{i==0?'$'+productentry?.basePrice?.value:''}}
                                                        </td>
                                                        <td class="right">{{i==0?(productentry.sim_excise_tax.value|currency:'USD'
                                                        :'symbol' : '1.2-2'):''}}</td>
                                                        <td class="right">
                                                          {{i==0?((productentry?.basePrice?.value+productentry.sim_excise_tax.value)*productentry.quantity|currency:'USD'
                                                          :'symbol' : '1.2-2'):''}}
                                                        </td>
                                                      </tr>
                                                    }
                                                  </tbody>
                                                }
                                              </table>
                                            </section>
                                          </section>
                                        </section>
                                      }
                                    </div>
                                  </div>
                                </section>
                              </div>
                            </section>
                          </div>
                        }
                        <!-- accordion: end-->
                      </section>
                    </section>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12 md-ipad-4">
      <aside class="
      col-md-12 col-sm-12
      right-navigation
      float-left
      left-align
      cart-main-page dst-orderSubtotal" aria-label="subTotal">
                  <section class="savings-total p-0 two" [ngClass]="isSticky === true ? 'header' : ''">
                    <div class="row">
                      <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
                        <div class="orderTitleSticky">
                          Order Total:
                          @if (headerLevelObj.length==0 && !updateTotal) {
                            <span>
                              {{subTotalVal | currency : 'USD' : 'symbol' : '1.2-2'}}
                            </span>
                          } @else {
                            <ng-template [ngTemplateOutlet]="noPrice"></ng-template>
                          }
                          @if (headerLevelObj.length>0) {
                            <span>$--</span>
                          }
                        </div>
                        <p class="fw-bold m-0 p-0">Total Savings:&nbsp;@if (headerLevelObj.length==0) {
                          <span class="greenfont"
                            >{{totalSavings | currency : 'USD' :
                          'symbol' : '1.2-2'}}</span>
                        }
                        @if (headerLevelObj.length>0) {
                          <span>$--</span>
                        }
                      </p>
                    </div>
                  </div>
                  @if (!updateTotal) {
                    <button type="button" class="btn-primary" (click)="openmodal(content)"
                      [disabled]="continueDisableCheck()" [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
                      @if (checkoutClicked) {
                        <i class="fa fa-spinner fa-spin"></i>
                      }
                      Continue
                    </button>
                  }
                  <button class="btn-secondary" (click)="updateCart()">
                    Edit Cart
                  </button>
                  <div class="row m-0 p-0">
                    <div class="col-md-12 col-lg-12 col-sm-12">
                      <div class="fw-bold m-0 p-0">By placing this order, you agree to the</div>
                    </div>
                  </div>
                  <div class="row m-0 p-0">
                    <div class="col-md-12 col-lg-12 col-sm-12">
                      <div class="fw-bold marginbot p-0"><a href="{{pdfUrl}}" target="_blank" class="fw-bold greenbtm">Terms &
                      Conditions</a></div>
                    </div>
                  </div>
                </section>
                <section>
                </section>
              </aside>
      <aside class="
      col-md-12 col-sm-12
      right-navigation
      float-left
      left-align
      cart-main-page" aria-label="subTotal">
                @if (!punchoutCheckout) {
                  <app-payment-method [stdCartType]="true"
                    (selectedPaymentMethodEvent)="selectedPaymentMethodDetailsMethod($event)" [stdCheckoutFlow]=true
                  (selectedCardOAcctDetailsEvent)="selectedCardOrAccountDetailsMethod($event)"></app-payment-method>
                }
                @if (!punchoutCheckout) {
                  <div class="row">
                    <div class="col-md-12 col-sm-12">
                      <h2 class="orderContact">
                      Order contact</h2>
                    </div>
                  </div>
                }
                @if (!punchoutCheckout) {
                  <div class="row billing-address">
                    <div class="col-md-6 col-sm-6 mobileWidth">
                      <h3 class="productCode">Billing Address</h3>
                      <p class="dataforaddblock">{{orderContactDetails?.accountNumber}}<br />
                        @if (orderContactDetails?.companyName) {
                          <span>{{orderContactDetails?.companyName}}<br /></span>
                        }
                        <!-- CTR FOR DISEASE CONTROL AND PREV<br /> -->
                        {{orderContactDetails?.formattedAddress}}
                      </p>
                    </div>
                    <div class="col-md-6 col-sm-6 mobileWidth">
                      <h3 class="productCode">Payer address</h3>
                      <p class="dataforaddblock">{{payerAddress?.accountNumber}}<br />
                        @if (payerAddress?.companyName) {
                          <span>{{payerAddress?.companyName}}<br /></span>
                        }
                        <!-- CTR FOR DISEASE CONTROL AND PREV<br /> -->
                        {{payerAddress?.formattedAddress}}
                      </p>
                    </div>
                  </div>
                }
              </aside>
            </div>
          </div>
        </section>
      } @else {
        <app-empty-cart compName="EmptyCartParagraphComponent"></app-empty-cart>
      }

      <ng-template #content let-modal>
        <div class="modal-header">

          <h3 class="modal-title modalTitle">Ready to place your order?</h3>
        </div>
        <div class="modal-body">

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12">
              <div class="fw-bold-center marginleftCls p-0">Order total</div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12">
              <div class="fw-bold-centr-amount marginleftCls">
                @if (headerLevelObj.length==0) {
                  <span>{{subTotalVal | currency : 'USD' : 'symbol' :
                  '1.2-2'}}</span>
                }

                @if (headerLevelObj.length>0) {
                  <span>$--</span>
                }
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12">
              <div class="no-sort-center marginleftCls p-0">Total with Prompt Pay:
                @if (headerLevelObj.length==0) {
                  <span class="greenfont"> {{totalWithPromtPayDiscountSum | currency : 'USD' :
                  'symbol' : '1.2-2'}}</span>
                  } @if (headerLevelObj.length>0) {
                  <span>$--</span>
                }
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 separator">
              &nbsp;
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12">
              <div class="fw-bold-center marginleftCls p-0">Ship to locations</div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12">
              @for (itm of stdCartDetails; track itm; let i = $index) {
                <div>
                  <div class="fw-normal-center marginleftCls p-0">
                  {{itm?.shipToLoc_name}}({{itm?.shipToLoc_id}})</div>
                </div>
              }
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 separator">
              &nbsp;
            </div>
          </div>


          @if (!punchoutCheckout) {
            <div class="row">
              <div class="col-md-6 col-sm-6 col-lg-6">
                <div class="fw-bold-center marginleftCls p-0">Order Contact</div>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-6">
                <div class="fw-bold-center marginleftCls p-0">Payment Method</div>
              </div>
            </div>
          }
          @if (!punchoutCheckout) {
            <div class="row">
              @if (!isAsmUser) {
                <div class="col-md-6 col-sm-6 col-lg-6">
                  <div class="fw-normal-center marginleftCls p-0">{{contactDetails.contactName}}</div>
                </div>
              }
              @if (isAsmUser) {
                <div class="col-md-6 col-sm-6 col-lg-6">
                  <div class="fw-normal-center marginleftCls p-0">{{contactDetails.asmContactName}}</div>
                </div>
              }
              <div class="col-md-6 col-sm-6 col-lg-6">
                <div class="fw-normal-center marginleftCls p-0" [innerHTML]="paymentMethod">
                </div>
              </div>
            </div>
          }

          @if (!punchoutCheckout) {
            <div class="row">
              <div class="col-md-12 col-sm-12 col-lg-12 separator">
                &nbsp;
              </div>
            </div>
          }

          <div class="row m-0 p-0">
            @if (!punchoutCheckout) {
              <div class="col-lg-9 col-sm-9 col-md-9">
                @if (!updateTotal) {
                  <button type="button" class="btn-primary mt2 placeOrderBtn" (click)="proceedtoFinal()"
                    [disabled]="orderBlock || checkoutClicked || yfEntry" [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
                    @if (checkoutClicked) {
                      <i class="fa fa-spinner fa-spin"></i>
                    }
                    Yes, place order
                  </button>
                }
                <button class="btn-secondary mt2 EditOrderBtn" (click)="modal.dismiss()">
                  Edit Order
                </button>
              </div>
            }
            @if (punchoutCheckout) {
              <div class="col-lg-9 col-sm-9 col-md-9">
                @if (!updateTotal) {
                  <button type="button" class="btn-primary mt2 placeOrderBtn" (click)="punchoutCheck()"
                    [disabled]="orderBlock || checkoutClicked || yfEntry" [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
                    @if (checkoutClicked) {
                      <i class="fa fa-spinner fa-spin"></i>
                    }
                    Transfer order
                  </button>
                }
                <button class="btn-secondary mt2 EditOrderBtn" (click)="modal.dismiss();redirectToCart()">
                  Edit Cart
                </button>
              </div>
            }
          </div>

        </div>
      </ng-template>
